import { Core_SimpleHealthInsuranceType } from '@/generated/graphql';
import { Form, Input, Select, Space } from 'antd';
import { Maybe } from 'graphql/jsutils/Maybe';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSimpleHealthInsuranceTypeFormatter } from '../../helpers/enum-formatters/useSimpleHealthInsuranceTypeFormatter';

export interface InsuranceInfoFormProps {
  insuranceType: Maybe<Core_SimpleHealthInsuranceType>;
  onInsuranceTypeChange: (value: Maybe<Core_SimpleHealthInsuranceType>) => void;
  insuranceNumber: string | undefined;
  onInsuranceNumberChange: (value: string) => void;
  insurerNumber: string | undefined;
  onInsurerNumberChange: (value: string) => void;
}

export const InsuranceInfoForm: FC<InsuranceInfoFormProps> = ({
  insuranceType,
  onInsuranceTypeChange,
  insuranceNumber,
  onInsuranceNumberChange,
  insurerNumber,
  onInsurerNumberChange,
}) => {
  const { formatMessage } = useIntl();
  const { formatSimpleHealthInsuranceType } = useSimpleHealthInsuranceTypeFormatter();

  return (
    <Form layout={'vertical'}>
      <Space style={{ width: '100%' }} direction={'vertical'} size={16}>
        <Form.Item label={formatMessage({ id: 'signup.insurance-type' })}>
          <Select
            size={'large'}
            value={insuranceType}
            placeholder={formatMessage({ id: 'placeholder' })}
            onChange={(value) => onInsuranceTypeChange(value)}
            options={Object.values(Core_SimpleHealthInsuranceType).map((type) => ({
              value: type,
              label: formatSimpleHealthInsuranceType(type),
            }))}
          />
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'signup.insurance-number' })}>
          <Input
            size={'large'}
            value={insuranceNumber}
            placeholder={formatMessage({ id: 'placeholder' })}
            allowClear
            onChange={(e) => onInsuranceNumberChange(e.target.value)}
          />
        </Form.Item>
        <Form.Item label={formatMessage({ id: 'signup.insurer-number' })}>
          <Input
            size={'large'}
            value={insurerNumber}
            placeholder={formatMessage({ id: 'placeholder' })}
            allowClear
            onChange={(e) => onInsurerNumberChange(e.target.value)}
          />
        </Form.Item>
      </Space>
    </Form>
  );
};
